import { AppRouter } from "./router/AppRouter";
import { AppTheme } from "./theme/AppTheme";

export const TicoticketApp = () => {
    return (
        <>
            <AppTheme>
                <AppRouter />
            </AppTheme>
        </>
    )
}
